export default __webpack_public_path__ + "static/bratz-banner-mobile-03d48d1abf5a01a3df5cdf6cd11e6215.webp";